<template>
  <section class="max-w-7xl mx-auto px-6 py-20">
    <!-- <h1 class="text-4xl font-bold text-center text-gray-800 mb-14">
      Complete Dental Solutions in Guwahati- MAGNUM DENTAL CLINIC
    </h1> -->
    <div class="text-center mb-16">
      <h1 class="text-3xl sm:text-4xl md:text-5xl
           font-extrabold font-serif tracking-tight
           text-[#924f19] mb-4">
        Complete Dental Solutions in Guwahati<br />
        <span class="block mt-2 text-2xl sm:text-3xl md:text-4xl">
          Magnum Dental Clinic
        </span>
      </h1>

      <p class="text-gray-600 max-w-2xl mx-auto text-base md:text-lg leading-relaxed">
        From preventive care to advanced dental treatments, we offer comprehensive
        solutions designed for comfort, precision, and long-term oral health.
      </p>
    </div>



    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      <router-link v-for="treatment in treatments" :key="treatment.path" :to="treatment.path" class="p-6 bg-white rounded-2xl shadow hover:shadow-lg
               transition border hover:border-teal-500">
        <h3 class="text-xl font-semibold text-teal-700 mb-2">
          {{ treatment.name }}
        </h3>
        <p class="text-gray-600 text-sm">
          Learn more about {{ treatment.name.toLowerCase() }} at Magnum Dental.
        </p>
      </router-link>
    </div>
  </section>
</template>

<script>
import { useHead } from "@vueuse/head";

export default {
  setup() {
    useHead({
      title: "Dental Treatments in Guwahati | Magnum Dental Clinic",
      meta: [
        {
          name: "description",
          content:
            "Magnum Dental Clinic Guwahati offers complete dental solutions — teeth cleaning, root canal, implants, braces, dentures, kids dentistry, smile designing, and more.",
        },
        {
          name: "robots",
          content: "index, follow",
        },
        {
          property: "og:title",
          content: "Dental Treatments in Guwahati | Magnum Dental Clinic",
        },
        {
          property: "og:url",
          content: "https://www.magnumdentalguwahati.in/dental-services",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.magnumdentalguwahati.in/dental-services" },
      ],
    });
  },
  data() {
    return {
      treatments: [
        { name: "Teeth Cleaning / Scaling", path: "/treatments/teeth-cleaning-in-guwahati" },
        { name: "Dental Fillings", path: "/treatments/dental-filling-in-guwahati" },
        { name: "Root Canal Treatment (RCT)", path: "/treatments/root-canal-treatment-in-guwahati" },
        { name: "Braces & Aligners", path: "/treatments/dental-braces-in-guwahati" },
        { name: "Dentures", path: "/treatments/dentures-in-guwahati" },
        { name: "Dental Extractions", path: "/treatments/dental-extractions-in-guwahati" },
        { name: "Wisdom Tooth Removal (Disimpaction)", path: "/treatments/wisdom-tooth-removal-in-guwahati" },
        { name: "Dental Implants", path: "/treatments/dental-implants-in-guwahati" },
        { name: "Crowns & Bridges", path: "/treatments/tooth-replacement-in-guwahati" },
        { name: "Kids Dentistry", path: "/treatments/kids-dentistry-in-guwahati" },
        { name: "Teeth Whitening", path: "/treatments/teeth-whitening-in-guwahati" },
        { name: "Smile Designing", path: "/treatments/smile-designing-magnum-dental-clinic-guwahati" },
        { name: "Gum Treatment & Surgery", path: "/treatments/gum-treatment-in-guwahati" },
      ],
    };
  },
};
</script>
